import { render, staticRenderFns } from "./SeveralDocuments.vue?vue&type=template&id=7ce85b2c&"
import script from "./SeveralDocuments.ts?vue&type=script&lang=ts&"
export * from "./SeveralDocuments.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports